/**
 * Jazz binding for the `ProjectStore` port. Components go through
 * `hooks/useProjectStore` rather than importing this directly, so the
 * backend choice lives in one place.
 */
import { useMemo } from "react";
import { useAccount } from "jazz-tools/react";
import { VibeDiagramAccount } from "./schema";
import { JazzProjectStore } from "../stores/JazzProjectStore";
import type { ProjectStore } from "../stores/ProjectStore";

/** Null while the account is still being set up. */
export function useJazzProjectStore(): ProjectStore | null {
  const { me } = useAccount(VibeDiagramAccount, {
    resolve: {
      root: {
        projects: { $each: true },
        authorizedAccounts: { $each: true },
      },
    },
  });

  return useMemo(() => (me ? new JazzProjectStore(me) : null), [me]);
}
